import {apiV2ListLink, Scenario} from "@pg-mono/rp-api-routes";

import {rpApi} from "../../../app/api/rp_api";
import {IRPStore} from "../../../app/rp_reducer";
import {IRegionListMap} from "../../../region/types/IRegionListMap";
import {getAllRegionTypesFromStore} from "../../../region/utils/get_all_region_types_from_store";
import {SEARCH_REGIONS_LIMIT} from "../../../search/constants/search_regions";
import {getIgnoredNotifyResponse} from "../../../store/utils/get_ignored_notify_response";

interface IRequestParams {
    region?: number | number[];
    regionFullName?: string;
}

interface IResponse {
    results: IRegionListMap[];
}

const multiRegionListLink = apiV2ListLink.region.list(Scenario.REGION_LIST_MAP);

export const getMapRegion = rpApi.injectEndpoints({
    endpoints: (build) => ({
        getMapRegions: build.query<IResponse, IRequestParams>({
            queryFn: async ({region, regionFullName}, {getState}, _extraOptions, baseQuery) => {
                if (!regionFullName && (!region || (Array.isArray(region) && region.length === 0))) {
                    return {
                        data: {
                            results: []
                        }
                    };
                }

                const allRegionTypeValues = getAllRegionTypesFromStore(getState() as IRPStore);
                const baseQueryResult = await baseQuery({
                    url: multiRegionListLink,
                    params: {
                        ...(regionFullName
                            ? {
                                  full_name: regionFullName
                              }
                            : {
                                  region
                              }),
                        type: allRegionTypeValues,
                        page_size: SEARCH_REGIONS_LIMIT
                    }
                });

                if (baseQueryResult.error) {
                    if (!getIgnoredNotifyResponse(baseQueryResult.error, [400, 404]).ignoreNotify) {
                        return {
                            data: {
                                results: []
                            }
                        };
                    } else {
                        return {error: baseQueryResult.error};
                    }
                }

                return {data: baseQueryResult.data as IResponse};
            }
        })
    })
});

export const {useGetMapRegionsQuery, useLazyGetMapRegionsQuery} = getMapRegion;
